import { Pipe, PipeTransform } from '@angular/core';
import { Process } from '../models/process.model';

@Pipe({
  name: 'displayOrderPattern',
})
export class DisplayOrderPatternPipe implements PipeTransform {
  constructor() {
  }

  transform(value: number, process: Process): string {
    if (!process) return ``;
    if (process.displayNumberBy == 'order')
      return `${value}`;
    else {
      return process.questionNumberPattern.replace('{{i}}', `${value}`);
    }
  }
}
